jQuery(document).ready(function(){
  jQuery('details.mega-menu').mouseenter(function() {
    jQuery(this).attr('open',true);
    jQuery(this).find('summary').attr('aria-expanded', true);
  });
  
  jQuery('details.mega-menu').mouseleave(function() {
    jQuery(this).removeAttr('open');
    jQuery(this).find('summary').attr('aria-expanded', false);
  });
  
  jQuery('.mega-menu__content').mouseenter(function() {
    jQuery(this).parent().attr('open',true);
    jQuery(this).find('summary').attr('aria-expanded', true);
  });
  
  jQuery('.mega-menu__content').mouseleave(function() {
    jQuery(this).parent().removeClass('open');
    jQuery(this).find('summary').attr('aria-expanded', false);
  });

  jQuery('nav.header__inline-menu div#MegaMenu-Content-8 ul.mega-menu__list.page-width').each(function() {
    for(x=0; x<3; x++){
      jQuery(this).append("<li>");
    }
  });
  jQuery('details#Details-menu-drawer-menu-item-8').click(function(){
    jQuery(this).find('details#Details-menu-drawer-submenu-1').attr('open','open');
    jQuery(this).find('details#Details-menu-drawer-submenu-1').addClass('menu-opening');
  });
  jQuery('#childlink-brands').click(function(){
    jQuery('details#Details-menu-drawer-menu-item-8').removeClass('menu-opening');
    jQuery('details#Details-menu-drawer-menu-item-8').removeAttr('open');
  });
});

// window.addEventListener(
//   "touchmove",
//   function (event) {
//     if (event.scale !== 1) {
//       event.preventDefault();
//       event.stopImmediatePropagation();
//     }
//   },
//   { passive: false }
// );

